export const ru = {
    BYN: 'BYN',
    CHF: '₣',
    EUR: '€',
    KZT: '₸',
    RUB: '₽',
    TRY: '₺',
    UAH: '₴',
    USD: '$',
    UZS: 'UZS',
    YND_FIXED: 'у.е.'
};
